/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Log } from '../logging';
import { ITivoSubscription } from './ITivoSubscription';

export class TivoSubscriptionModel<T> implements ITivoSubscription<T> {
    private static TAG: string = 'TivoSubcriptionModel';

    private mCounter: number;

    private mHasError: boolean;

    private mSubscribers: Map<number, Function>;

    public constructor() {
        this.mCounter = 0;
        this.mHasError = false;
        this.mSubscribers = new Map<number, Function>();
    }

    /**
     * @inheritdoc
     */
    public cancel(callback: Function): void {
        this.mSubscribers.forEach((subscriber, key) => {
            if (callback === subscriber) {
                this.mSubscribers.delete(key);
            }
        });
    }

    /**
     * @inheritdoc
     */
    public cancelAll(): void {
        this.mCounter = 0;
        this.mHasError = false;
        this.mSubscribers = new Map<number, Function>();
    }

    /**
     * @inheritdoc
     */
    public hasError(): boolean {
        return this.mHasError;
    }

    /**
     * @inheritdoc
     */
    public notify(data: T): void {
        this.mSubscribers.forEach((subscriber) => {
            try {
                subscriber(data);
            } catch (error) {
                Log.e(TivoSubscriptionModel.TAG, 'Error while notifying.');
                this.mHasError = true;
                Log.e(TivoSubscriptionModel.TAG, 'stacktrace:', error);
            }
        });
    }

    /**
     * @inheritdoc
     */
    public subscribe(callback: Function): void {
        this.mCounter += 1;
        this.mSubscribers.set(this.mCounter, callback);
    }
}
